import type {LogNamespaceKeyType} from "../../config/logger";
import {loggerNamespaces} from "../../config/logger";
import type {LoggerServiceType} from "./logger-types";
import type {LoggerServiceNamespace} from "./logger-service-namespace";


const loggerServiceProxyHandler: ProxyHandler<LoggerServiceType> = {
  get(target, propertyKey: string, _receiver: unknown){

    // see if propertyKey is logger namespace
    if (propertyKey in loggerNamespaces) {
      return target.getNamespace(loggerNamespaces[propertyKey as LogNamespaceKeyType]);
    }
    // see if propertyKey is a part of LoggerService
    if (propertyKey in target) {
      return target[propertyKey as keyof LoggerServiceType];
    }

    // unknown propertyKey
    return undefined;
  },

  set(_target, _propertyKey: string, _value: unknown, _receiver: unknown): boolean {
    // we don't allow set for anything
    return false;
  }
}

export type LoggerServiceWithNamespacesType = Record<LogNamespaceKeyType, LoggerServiceNamespace>;

/**
 * Wrap logging service in proxy
 * This will allow it to work with all configured logging namespaces
 * without requiring all to be manually configured
 * @param loggerService
 */
export const proxyLoggerService = (loggerService: LoggerServiceType) =>
  new Proxy<LoggerServiceType>(loggerService, loggerServiceProxyHandler) as LoggerServiceType & LoggerServiceWithNamespacesType;
